import { apiSlice } from "../../apiSlice";

export const dashestxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDashboards: builder.query({
      query: () => `/Paramgen/dashestx`,
      providesTags: ["Dashestx"],
    }),
    getDashboardById: builder.query({
      query: (DASHIDXX) => `/Paramgen/dashestx/${DASHIDXX}`,
      providesTags: ["Dashestx"],
    }),
    createDashboard: builder.mutation({
      //Multipart: el tablero se crea junto con el HTML de su primera version
      query: (formData) => ({
        url: `/Paramgen/dashestx`,
        method: "POST",
        body: formData,
        formData: true,
      }),
      invalidatesTags: ["Dashestx"],
    }),
    updateDashboard: builder.mutation({
      query: (parameters) => ({
        url: `/Paramgen/dashestx/${parameters.DASHIDXX}`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Dashestx"],
    }),
    activeInactiveDashboard: builder.mutation({
      query: (parameters) => ({
        url: `/Paramgen/dashestx/${parameters.DASHIDXX}/${parameters.REGESTXX}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Dashestx"],
    }),
    uploadVersion: builder.mutation({
      query: ({ DASHIDXX, formData }) => ({
        url: `/Paramgen/dashestx/${DASHIDXX}/upload`,
        method: "POST",
        body: formData,
        formData: true,
      }),
      invalidatesTags: ["Dashestx"],
    }),
    getVisibles: builder.query({
      query: () => `/Paramgen/dashestx/visibles`,
      providesTags: ["Dashestx"],
    }),
    getContent: builder.query({
      query: ({ DASHIDXX, VERPERXX }) => ({
        url: VERPERXX
          ? `/Paramgen/dashestx/${DASHIDXX}/content/${VERPERXX}`
          : `/Paramgen/dashestx/${DASHIDXX}/content`,
        responseHandler: (response) => response.text(),
      }),
    }),
  }),
});

export const {
  useGetDashboardsQuery,
  useGetDashboardByIdQuery,
  useCreateDashboardMutation,
  useUpdateDashboardMutation,
  useActiveInactiveDashboardMutation,
  useUploadVersionMutation,
  useGetVisiblesQuery,
  useLazyGetContentQuery,
} = dashestxApiSlice;
